export function str2num(str, point = 2) {
    if (isNaN(str)) {
        return NaN
    }
    str = str + ''
    str = str.trim()
    const point_index = str.indexOf('.')
    if (point_index === -1) {
        return str
    }
    return str.slice(0, point_index + point + 1)
}